import { useTranslation } from 'react-i18next';
import { BlackBar } from 'ui/shell/blackBar/BlackBar';
import { Switch, Route } from 'react-router-dom';
import { ResetPasswordPage } from '../reset-password/resetPasswordPage/ResetPasswordPage';
import { VerifyResetPasswordPage } from '../verify-reset-password/verifyResetPasswordPage/VerifyResetPasswordPage';
import { LoginPage } from '../login/loginPage/LoginPage';
import './WelcomeArea.css';

const logoImgSrc = require('assets/images/mosaicone-logo.png');
const dmgLogoImgSrc = require('assets/images/DMG-logo-small.png');
const madLogoImgSrc = require('assets/images/MAD-logo-small.png');
const ttgLogoImgSrc = require('assets/images/TTG-logo-small.png');

const welcomeImgSrc = require('assets/images/welcome.jpg');

const heroStyle = {
    background: `url(${welcomeImgSrc}) 100% 0px / cover no-repeat transparent`,
};

export const WelcomeArea = () => {
    const { t } = useTranslation();
    return (
        <div id="welcome">
            <div id="welcome-header">
                <BlackBar/>
            </div>
            <div id="welcome-area">
                <div className="hero" style={ heroStyle }/>
                <div id="page-content" style={ { padding: '0 3em' } }>
                    <img src={ logoImgSrc } style={ { width: '225px', height: '160px' } } className="logo" alt=""/>
                    <div
                        style={ {
                            textAlign: 'center',
                            margin: '0 auto 4em auto',
                            width: '425px',
                        } }
                    >
                        { t('WELCOME_AREA.MESSAGE') }
                    </div>
                    <div>
                        <Switch>
                            <Route exact path="/reset-password" component={ ResetPasswordPage }/>
                            <Route exact path="/reset-password/:resetToken" component={ VerifyResetPasswordPage }/>
                            <Route component={ LoginPage }/>
                        </Switch>
                    </div>
                    <div style={ { textAlign: 'center', marginTop: '3em' } }>
                        { t('WELCOME_AREA.COMPANIES') }
                    </div>
                    <div style={ { textAlign: 'center', marginTop: '1em' } }>
                        <a href="http://www.dmg.it/ita/index.php">
                            <img src={ dmgLogoImgSrc } id="dmg-logo-small" alt=""/>
                        </a>
                        <a href="https://www.madelevator.com/">
                            <img src={ madLogoImgSrc } id="mad-logo-small" alt=""/>
                        </a>
                        <a href="http://www.touchtogo.ca/">
                            <img src={ ttgLogoImgSrc } id="ttg-logo-small" alt=""/>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    );
};
